export const CLEAR_REPORTS = 'CLEAR_REPORTS';
export const GET_STATISTIC_REPORT = 'GET_STATISTIC_REPORT';
export const GET_STATISTIC_REPORT_SUCCESS = 'GET_STATISTIC_REPORT_SUCCESS';
export const GET_STATISTIC_REPORT_FAILED = 'GET_STATISTIC_REPORT_FAILED';
export const GET_INVOICE_REPORT = 'GET_INVOICE_REPORT';
export const GET_INVOICE_REPORT_SUCCESS = 'GET_INVOICE_REPORT_SUCCESS';
export const GET_INVOICE_REPORT_FAILED = 'GET_INVOICE_REPORT_FAILED';
export const GET_USER_MANAGEMENT_REPORT = 'GET_USER_MANAGEMENT_REPORT';
export const GET_USER_MANAGEMENT_REPORT_SUCCESS = 'GET_USER_MANAGEMENT_REPORT_SUCCESS';
export const GET_USER_MANAGEMENT_REPORT_FAILED = 'GET_USER_MANAGEMENT_REPORT_FAILED';
export const GET_USER_AUDIT_TRAIL_REPORT = 'GET_USER_AUDIT_TRAIL';
export const GET_USER_AUDIT_TRAIL_REPORT_SUCCESS = 'GET_USER_AUDIT_TRAIL_SUCCESS';
export const GET_USER_AUDIT_TRAIL_REPORT_FAILED = 'GET_USER_AUDIT_TRAIL_FAILED';
export const GET_DOCUMENT_TRAIL_REPORT = 'GET_DOCUMENT_TRAIL_REPORT';
export const GET_DOCUMENT_TRAIL_REPORT_SUCCESS = 'GET_DOCUMENT_TRAIL_REPORT_SUCCESS';
export const GET_DOCUMENT_TRAIL_REPORT_FAILED = 'GET_DOCUMENT_TRAIL_REPORT_FAILED';
export const GET_MASTER_VIEW_REPORT = 'GET_MASTER_VIEW_REPORT';
export const GET_MASTER_VIEW_REPORT_SUCCESS = 'GET_MASTER_VIEW_REPORT_SUCCESS';
export const GET_MASTER_VIEW_REPORT_FAILED = 'GET_MASTER_VIEW_REPORT_FAILED';

export const GET_MASS_UPDATE_LOG = 'GET_MASS_UPDATE_LOG';
export const GET_MASS_UPDATE_LOG_SUCCESS = 'GET_MASS_UPDATE_LOG_SUCCESS';
export const GET_MASS_UPDATE_LOG_FAILED = 'GET_MASS_UPDATE_LOG_FAILED';
